import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var ThemeDefault = /*#__PURE__*/function () {
  function ThemeDefault() {
    _classCallCheck(this, ThemeDefault);
    this.auto = false;
    this.mode = "any";
    this.value = false;
  }
  _createClass(ThemeDefault, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.auto !== undefined) {
        this.auto = data.auto;
      }
      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
      if (data.value !== undefined) {
        this.value = data.value;
      }
    }
  }]);
  return ThemeDefault;
}();